/**
 * Zwijane bloki treści (opis produktu, tabela cech).
 *
 * Progresywnie: bez JS blok zostaje rozwinięty w całości, a przycisk siedzi pod `hidden`.
 * Dopiero skrypt sprawdza, czy treść w ogóle wystaje ponad wysokość podglądu - krótkiego
 * opisu nie ma po co zwijać - i wtedy zwija blok oraz pokazuje przełącznik.
 */

const COLLAPSED_CLASS = 'is-collapsed';
// margines na "prawie mieści się": zwijanie treści dłuższej o kilkanaście pikseli
// dawałoby przycisk, który po kliknięciu prawie nic nie odsłania
const OVERFLOW_TOLERANCE = 80;

function collapsedHeight(block) {
    const fromData = parseInt(block.dataset.expandableHeight ?? '', 10);
    if (!Number.isNaN(fromData)) {
        return fromData;
    }

    // wartość z CSS (--expandable-height), żeby wysokość podglądu ustawiał arkusz, nie skrypt
    const fromCss = parseFloat(getComputedStyle(block).getPropertyValue('--expandable-height'));

    return Number.isNaN(fromCss) ? 400 : fromCss;
}

function setLabel(toggle, expanded) {
    toggle.textContent = expanded
        ? (toggle.dataset.labelLess ?? 'Zwiń')
        : (toggle.dataset.labelMore ?? 'Pokaż więcej');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

function bindBlock(block) {
    if ('1' === block.dataset.expandableReady) {
        return;
    }

    const content = block.querySelector('.expandable-content');
    const toggle = block.querySelector('.expandable-toggle');

    if (null === content || null === toggle) {
        return;
    }

    // blok zostaje nietknięty i bez znacznika: opis bywa pełen obrazków, więc po ich
    // doczytaniu urośnie i drugie przejście (na window.load) zwinie go już poprawnie
    if (content.scrollHeight <= collapsedHeight(block) + OVERFLOW_TOLERANCE) {
        return;
    }

    block.dataset.expandableReady = '1';
    block.classList.add(COLLAPSED_CLASS);
    toggle.hidden = false;
    setLabel(toggle, false);

    toggle.addEventListener('click', () => {
        const collapsing = !block.classList.contains(COLLAPSED_CLASS);
        block.classList.toggle(COLLAPSED_CLASS, collapsing);
        setLabel(toggle, !collapsing);

        // po zwinięciu góra bloku bywa nad ekranem - inaczej klient ląduje w środku
        // treści, która właśnie zniknęła
        if (collapsing && block.getBoundingClientRect().top < 0) {
            block.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    });
}

export function bind(scope = document) {
    const run = () => scope.querySelectorAll('[data-pl-expandable]').forEach(bindBlock);

    run();
    window.addEventListener('load', run, { once: true });
}
